var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 10C18.5 5.58172 14.9183 2 10.5 2C6.08172 2 2.5 5.58172 2.5 10C2.5 14.4183 6.08172 18 10.5 18C14.9183 18 18.5 14.4183 18.5 10ZM10.0081 8.91012C10.0504 8.67687 10.2545 8.49999 10.5 8.49999C10.7455 8.49999 10.9496 8.67687 10.9919 8.91012L11 8.99999V13.5021L10.9919 13.592C10.9496 13.8253 10.7455 14.0021 10.5 14.0021C10.2545 14.0021 10.0504 13.8253 10.0081 13.592L10 13.5021V8.99999L10.0081 8.91012ZM9.75 6.74999C9.75 6.33578 10.0858 5.99999 10.5 5.99999C10.9142 5.99999 11.25 6.33578 11.25 6.74999C11.25 7.16421 10.9142 7.49999 10.5 7.49999C10.0858 7.49999 9.75 7.16421 9.75 6.74999Z",
    fill: "#393B40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.23e5ae140ba8e1f49eb4aa538c803795.svg";
export { ForwardRef as ReactComponent };